<div class="chart-container">
  <div class="close-button">
    <button type="button" (click)="closeDialog($event)" aria-label="Close">×</button>
  </div>
  <div class="row">
    <div class="col-2">
      <div *ngIf="project?.ProPakProject?.Name" class="label-text">Project</div>
      <h3>{{project?.ProPakProject?.Name}}</h3>
    </div>
    <div class="col-2">
      <div *ngIf="project?.ProPakProject?.Asset?.Name" class="label-text">Asset</div>
      <h3>{{project?.ProPakProject?.Asset?.Name}}</h3>
    </div>
    <div class="col-2">
      <div class="label-text">Data</div>
      <h3>{{projectDataDate}}</h3>
    </div>
    <div class="col-2">
      <div *ngIf="project?.ProPakProject?.Asset?.Name" class="label-text">Baseline</div>
      <h3>{{baselineTargetFinish}}</h3>
    </div>
    <div class="col-2">
      <div class="label-text">Projected</div>
      <h3>{{projectedData}}</h3>
    </div>
    <div class="col-2">
      <div class="custom-legend">
        <div *ngFor="let series of chartData; let i = index">
          <span class="legend-color-box" [ngStyle]="{'background-color': colorScheme.domain[i]}"></span>
          <span>{{ series.name }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-2">
      <label for="startDate">From:</label>
      <input type="date" id="startDate" [(ngModel)]="startDate" [min]="projectTargetStartMIN"
        [max]="projectTargetFinishMAX">
    </div>
    <div class="col-lg-2">
      <label for="endDate">To:</label>
      <input type="date" id="endDate" [(ngModel)]="endDate" [min]="projectTargetStartMIN"
        [max]="projectTargetFinishMAX">
    </div>
    <div class="col-lg-1">
      <br />
      <button (click)="loadExecutionChartData()">Apply</button>
    </div>
    <div class="col-lg-2">
      <label>
        See Full Schedule</label>
      <input type="checkbox" [(ngModel)]="seeFullSchedule" (change)="toggleFullSchedule()">
    </div>
    <div class="col-lg-5">
    </div>
  </div>
  <br />
    <ngx-charts-line-chart class="mainChart" [scheme]="colorScheme" [legend]="legend" [showGridLines]="showGridLines"
      [xAxis]="xAxis" [yAxis]="yAxis" [results]="chartData" [curve]="curve" [autoScale]="autoScale"
      [timeline]="timeline" [legendTitle]="legendTitle" [tooltipDisabled]="false">

      <ng-template #seriesTooltipTemplate let-model="model">
        <div class="chart-tooltip">
          <div *ngFor="let m of getSecondValueForDate(model); let i = index;"><fa-icon class="chart-icon-{{m.series}}" [icon]="faSquare"
              size="xs"></fa-icon> {{m.series}} • {{m.value}}%</div>
        </div>
      </ng-template>
    </ngx-charts-line-chart>
</div>